import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 container" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  class: "form mt-4",
  id: "form"
}
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "form-group w-25" }
const _hoisted_7 = { for: "initDate" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = { class: "form-group w-25" }
const _hoisted_10 = { for: "checkIn" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { for: "daysWeek" }
const _hoisted_14 = { class: "d-flex gap-1" }
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "form-group w-25 justify-content-center" }
const _hoisted_19 = { for: "checkOut" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "form-group toggle w-25 d-flex align-items-end justify-content-center" }
const _hoisted_22 = {
  key: 0,
  for: "toggleFields",
  class: "me-4"
}
const _hoisted_23 = {
  key: 1,
  for: "toggleFields",
  class: "me-4"
}
const _hoisted_24 = { class: "form-group w-25" }
const _hoisted_25 = { for: "finishDate" }
const _hoisted_26 = { class: "mb-5 mt-3 pb-5" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { style: {"height":"calc(100vh - 450px)","overflow":"hidden","position":"relative"} }
const _hoisted_29 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center position-absolute w-100 h-100",
  style: {"background-color":"rgba(255, 255, 255, 0.6)","z-index":"10","top":"0","left":"0"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", {
  class: "availability-event__icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "14",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "21"
  })
], -1)
const _hoisted_33 = { class: "availability-event__count" }
const _hoisted_34 = { class: "availability-event__label" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  class: "availability-event__icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "14",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "21"
  })
], -1)
const _hoisted_36 = { class: "availability-event__month-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOptions = _resolveComponent("DialogOptions")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ds_toggle_button = _resolveComponent("ds-toggle-button")!
  const _component_Qalendar = _resolveComponent("Qalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DialogOptions, {
      group: _ctx.confirmGroup,
      "schedule-information": _ctx.scheduleInfoDialog
    }, null, 8, ["group", "schedule-information"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.scheduleId ? _ctx.$t("schedule.editSchedule") : _ctx.$t("schedule.new")), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.cancel'),
          class: "float-start me-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/agendamento')))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: 'salvar',
          class: "float-end",
          form: "form",
          onClick: _ctx.sendShedule
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("schedule.fields.date")), 1),
            _createVNode(_component_Calendar, {
              id: "initDate",
              name: "initDate",
              placeholder: "DD/MM/YYYY",
              "date-format": "dd/mm/yy",
              "min-date": new Date(),
              modelValue: _ctx.schedule.initDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schedule.initDate) = $event)),
              class: _normalizeClass(`w-100 ${_ctx.v$.schedule.initDate.$error ? 'p-invalid' : ''}`)
            }, null, 8, ["min-date", "modelValue", "class"]),
            _createElementVNode("small", null, [
              (_ctx.v$.schedule.initDate.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("schedule.fields.startHour")), 1),
            _createVNode(_component_Calendar, {
              id: "checkIn",
              name: "checkIn",
              placeholder: "HH:MM",
              modelValue: _ctx.schedule.calendarList[0].checkIn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schedule.calendarList[0].checkIn) = $event)),
              timeOnly: "",
              class: _normalizeClass(`w-100 ${
                _ctx.v$.schedule.calendarList[0].checkIn.$error ? 'p-invalid' : ''
              }`)
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("small", null, [
              (_ctx.v$.schedule.calendarList[0].checkIn.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("group.fields.weekDays")), 1),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: day.value,
                  class: "checkdiv d-flex align-items-center flex-column"
                }, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selectedDays,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDays) = $event)),
                    InputId: day.name,
                    id: day.name,
                    label: _ctx.navigator == 'pt-BR' ? day.label : day.enLabel,
                    name: day.name,
                    value: day.value,
                    disabled: _ctx.disabled
                  }, null, 8, ["modelValue", "InputId", "id", "label", "name", "value", "disabled"]),
                  _createElementVNode("label", {
                    class: "checkLabel",
                    for: day.name
                  }, _toDisplayString(_ctx.navigator == "pt-BR" ? day.label : day.enLabel), 9, _hoisted_15)
                ]))
              }), 128))
            ]),
            (_ctx.noDaysSelected)
              ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.schedule.recurrence]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("schedule.fields.finishHour")), 1),
            _createVNode(_component_Calendar, {
              id: "checkOut",
              name: "checkOut",
              placeholder: "HH:MM",
              modelValue: _ctx.schedule.calendarList[0].checkOut,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schedule.calendarList[0].checkOut) = $event)),
              timeOnly: "",
              class: _normalizeClass(`w-100 ${
                _ctx.v$.schedule.calendarList[0].checkOut.$error ? 'p-invalid' : ''
              }`)
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("small", null, [
              (_ctx.v$.schedule.calendarList[0].checkOut.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.scheduleId == null)
              ? (_openBlock(), _createElementBlock("label", _hoisted_22, _toDisplayString(_ctx.$t("schedule.fields.recurrent")), 1))
              : (_ctx.scheduleId)
                ? (_openBlock(), _createElementBlock("label", _hoisted_23, _toDisplayString(_ctx.$t("schedule.fields.seeRecurrence")), 1))
                : _createCommentVNode("", true),
            _createVNode(_component_ds_toggle_button, {
              id: "toggleFields",
              class: "mb-1 w-25",
              "onUpdate:isActive": _ctx.getToggleValue
            }, null, 8, ["onUpdate:isActive"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("schedule.fields.finishDate")), 1),
            _createVNode(_component_Calendar, {
              id: "finishDate",
              name: "finishDate",
              placeholder: "DD/MM/YYYY",
              "date-format": "dd/mm/yy",
              "min-date": new Date(_ctx.schedule.initDate),
              modelValue: _ctx.schedule.finishDate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schedule.finishDate) = $event))
            }, null, 8, ["min-date", "modelValue"])
          ], 512), [
            [_vShow, _ctx.schedule.recurrence]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t("schedule.availability.title")), 1),
      _createElementVNode("div", _hoisted_28, [
        (_ctx.isLoadingAvailability)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_component_Qalendar, {
          key: _ctx.calendarKey,
          events: _ctx.availableComputersEvents,
          config: _ctx.calendarConfig,
          "selected-date": _ctx.selectedCalendarDate
        }, {
          weekDayEvent: _withCtx(({ eventData }) => [
            _createElementVNode("div", {
              class: _normalizeClass([
                'availability-event',
                eventData.macCount > 0
                  ? 'availability-event--free'
                  : 'availability-event--full',
              ])
            }, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, _toDisplayString(eventData.macCount), 1),
              _createElementVNode("span", _hoisted_34, _toDisplayString(eventData.macLabel), 1)
            ], 2)
          ]),
          monthEvent: _withCtx(({ eventData }) => [
            _createElementVNode("div", {
              class: _normalizeClass([
                'availability-event availability-event--month',
                eventData.macCount > 0
                  ? 'availability-event--free'
                  : 'availability-event--full',
              ])
            }, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, [
                _createElementVNode("strong", null, _toDisplayString(eventData.macCount), 1),
                _createTextVNode(" " + _toDisplayString(eventData.macLabel), 1)
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["events", "config", "selected-date"]))
      ])
    ])
  ]))
}